import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CardService, AuthService, Guid, ErrorStateService } from '@fgb/core';

@Component({
  selector: 'fgb-mlbam-user-login',
  templateUrl: './mlbam-user-login.component.html',
  styleUrls: ['./mlbam-user-login.component.scss'],
})
export class MlbamUserLoginComponent implements OnInit {
  loginForm: FormGroup;
  submitted = false;
  loading = false;

  constructor(
    public cardService: CardService,
    public errorService: ErrorStateService,
    private authService: AuthService,
    private formBuilder: FormBuilder
  ) {}
  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  onSubmit() {
    this.loginForm.markAllAsTouched();
    if (!this.loginForm.valid) {
      return;
    }

    this.loading = true;
    const { username, password } = this.loginForm.value;

    this.authService
      .mlbamLogin(username.trim(), password.trim(), new Guid().toString().split('-').join(''))
      .toPromise()
      .catch(() => {
        this.loading = false;
        this.errorService.clearErrors();
        this.errorService.addError('Invalid Email Address and Password.');
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
